import React from "react";
import classes from "./AboutUs.module.css";
import Why from "./Why";
import VisionMission from "./VisionMission";
import Values from "./Values";
import { useTranslation } from "react-i18next";

function AboutUs() {
  const { t } = useTranslation();

  return (
    <div className={classes.aboutDiv} id="aboutSection">
      <h6>{t("Choose_Us.mainTitle")}</h6>
      <Why />
      <VisionMission />
      <Values />
    </div>
  );
}

export default AboutUs;
